<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-regulations" style="background: #fff">

        <page-title :title="'Regulamin'" :back="true"></page-title>

        <slide-y-up-transition :duration="700">
            <div v-show="show">
                <h3>§ 1.Definicje</h3>
                <ol>
                    <li>do uzupełnienia</li>
                    <li>do uzupełnienia</li>
                </ol>
            </div>
        </slide-y-up-transition>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';

    export default {
        name: 'Regulations',
        components: { PageTitle },
        data(){
            return {
                show: false,
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>